export default __webpack_public_path__ + "static/media/gesundheitpflege_dark.b517c643.png";